import { Flex, FlexProps } from '@chakra-ui/react';
import { PortfolioEventCardModel } from 'entities';
import React from 'react';
// eslint-disable-next-line no-restricted-imports
import { TopicCard } from 'shared/ui';

type EventTypePageMainEventsListProps = {
    events: PortfolioEventCardModel[]
} & FlexProps & React.RefAttributes<HTMLDivElement>

export const PortfolioEventsPageMainEventsList: React.FC<EventTypePageMainEventsListProps> = ({
    events,
    ...props
}) => (
    <Flex
        flexDirection="column"
        gap="2rem"
        {...props}
    >
        {events.map(({
            uid,
            name,
            description,
            images,
        }, index) => (
            <TopicCard
                key={uid}
                to={`/portfolio-events/${uid}`}
                title={name}
                description={description || []}
                imagesContainerType={(index % 2) === 0 ? 1 : 2}
                imagesSrcs={images?.map(({ url }) => url) || []}
            />
        ))}
    </Flex>
);
